module.exports = __webpack_public_path__ + "img/Modernisme_Norske_lyrikere3.300630ab.jpg";